var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-img',{attrs:{"src":require("./not_found.svg"),"contain":"","max-height":"40vh"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }